import { VacationTypes } from 'src/tabs/constants/Timeoff.constants';
import * as yup from 'yup';

export const schema = yup.object().shape({
  startDate: yup
    .date()
    .test(
      'is-greater-than-today',
      'Start date must be greater than yesterday.',
      function (value) {
        const today = new Date();
        if (value) {
          const startDate = new Date(value);
          if (startDate.getFullYear() === today.getFullYear()) {
            if (startDate.getMonth() >= today.getMonth()) {
              return true;
            }
            return startDate.getDate() >= today.getDate();
          }
        }
        return true;
      }
    )
    .test(
      'is-in-same-year',
      'Start date must be in the same year.',
      function (value) {
        const today = new Date();
        if (value) {
          const startDate = new Date(value);
          const allowedYear = startDate.getFullYear() - today.getFullYear();
          if (allowedYear < 2) {
            return true;
          }
        }
        if (value) {
          const startDate = new Date(value);
          return today.getFullYear() === startDate.getFullYear();
        }
        return true;
      }
    )
    .required('Start date is required.'),
  endDate: yup
    .date()
    .test(
      'is-greater-than-startDate',
      'End date must be greater than or equal to start date.',
      function (value) {
        const { startDate } = this.parent;
        if (startDate && value) {
          return new Date(value) >= new Date(startDate);
        }
        return true;
      }
    )
    .test(
      'is-in-same-year',
      'End date must be in the same year',
      function (value) {
        const { startDate } = this.parent;
        if (value && startDate) {
          const endDate = new Date(value);
          return startDate.getFullYear() === endDate.getFullYear();
        }
        return true;
      }
    )
    .required('End date is required.'),
  vacationType: yup
    .string()
    .oneOf(
      [
        'Court Duty Time-off',
        'Sick Leave',
        'Blood Donation Vacation',
        'Deceased Relative Time-off',
        'Marriage Vacation',
        'Maternity Time-off',
        'Paid Education Vacation',
        VacationTypes.PAID_VACATION,
        VacationTypes.PAID_VACATION_BONUS_DAYS,
        'Paternity Time-off',
        VacationTypes.UNPAID_VACATION,
      ],
      'Vacation type is required.'
    )
    .required('Vacation type is required.'),
  employeeComment: yup.string(),
});
